export default "__VITE_ASSET__CypPn8VN__"